import { useEffect } from 'react';

import { useUser } from 'global/UserContext';

const Logout = () => {
  const { logout } = useUser();

  useEffect(() => {
    console.log('ENTRANDO NO LOGOUT');
    logout();
  }, [logout]);

  return null;
};

export default Logout;
